import { OutagesFiltersI } from '@/types';
import { useState } from 'react';

const initialFilters = {
  siteId: null,
  startDate: null,
  endDate: null,
  query: '',
};

export const useOutagesFilters = () => {
  const [outagesFilters, setOutagesFilters] =
    useState<OutagesFiltersI>(initialFilters);

  const updateFilters = (filters: Partial<OutagesFiltersI>) => {
    setOutagesFilters((prevState) => ({ ...prevState, ...filters }));
  };

  const resetFilters = () => {
    setOutagesFilters(initialFilters);
  };

  return {
    outagesFilters,
    resetFilters,
    updateFilters,
  };
};
